/**
 * @generated SignedSource<<aa780f20d55143aae06a647ab44bc47a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MicrosoftTodoIntegrationListsQuery$variables = {};
export type MicrosoftTodoIntegrationListsQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly microsoftTodo: {
        readonly lists: ReadonlyArray<{
          readonly externalId: string;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type MicrosoftTodoIntegrationListsQuery = {
  response: MicrosoftTodoIntegrationListsQuery$data;
  variables: MicrosoftTodoIntegrationListsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrosoftTodoIntegrationListsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MicrosoftTodoListNode",
                    "kind": "LinkedField",
                    "name": "lists",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MicrosoftTodoIntegrationListsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MicrosoftTodoListNode",
                    "kind": "LinkedField",
                    "name": "lists",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "db836f4d266e5b5d55ecd79669c521f9",
    "id": null,
    "metadata": {},
    "name": "MicrosoftTodoIntegrationListsQuery",
    "operationKind": "query",
    "text": "query MicrosoftTodoIntegrationListsQuery {\n  viewer {\n    integrations {\n      microsoftTodo {\n        lists {\n          name\n          externalId\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aec94bf985165ce96112c8586f431d19";

export default node;
